/**
 * React Query hook for fetching AI review inspections data
 */
import { useQuery } from '@tanstack/react-query';
import InspectionsReviewService from '../services/InspectionsReviewService';
/**
 * Hook for fetching AI review inspections data
 * @param params - The parameters for the API call
 * @returns Query result with inspections data
 */
export default function useInspectionsReview(params) {
    return useQuery(['ai-review-inspections', params.page, params.sort, params.filters, params.asset], () => InspectionsReviewService.getInspectionsReview(params), {
        staleTime: 2 * 60 * 1000, // 2 minutes - shorter than other queries due to data freshness needs
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // exponential backoff with max of 30 seconds
        refetchOnWindowFocus: false,
        keepPreviousData: true // Keep previous data while fetching new data for better UX
    });
}
